import { useEffect, useState } from "react";
import { Menu, X, Heart } from "lucide-react";

const NAV = [
  { href: "#work", label: "Our Work" },
  { href: "#process", label: "Process" },
  { href: "#pricing", label: "Pricing" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Begin" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[rgba(11,10,9,0.75)] border-b border-[rgba(197,165,90,0.15)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-link" className="flex items-center gap-3 group">
          <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-[rgba(212,175,55,0.4)]">
            <Heart size={16} className="text-[#D4AF37]" strokeWidth={1.4} />
            <span className="absolute inset-0 rounded-full glow-pulse" style={{ boxShadow: "0 0 24px 2px rgba(212,175,55,0.35)" }} />
          </span>
          <div className="leading-tight">
            <div className="serif text-[20px] text-[#F5F0E8] tracking-wide">Eternal Legacy</div>
            <div className="overline text-[9px] text-[#C5A55A]/80">Tributes</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-[#A0988E] hover:text-[#F5F0E8] transition-colors tracking-wide"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a href="#contact" data-testid="header-cta" className="btn-primary text-sm">Start Your Tribute</a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-[rgba(197,165,90,0.2)]"
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[rgba(197,165,90,0.15)] bg-[rgba(11,10,9,0.95)] backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-[#F5F0E8]/90 py-2 border-b border-[rgba(197,165,90,0.08)]"
              >
                {n.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="btn-primary text-sm justify-center mt-2">Start Your Tribute</a>
          </div>
        </div>
      )}
    </header>
  );
}
